import React from 'react'
import './MyHeaderBg.css'
const bgImg = require('../../../images/HeadBg.jpg')

export default function MyHeaderBg (props) {
  const wrapperStyle = props.wrapperStyle || {} // 提示信息的文本样式 默认为空
  return (
    <div className='abs trbl0 zx-1 ovh rdsbottom' style={wrapperStyle}>
      <div className='h100 bgHeader' style={{ backgroundImage: `url(${bgImg})` }} />
    </div>
  )
}
